import { render, staticRenderFns } from "./CollegeStudentSignInManage.vue?vue&type=template&id=a3b1256e&scoped=true"
import script from "./CollegeStudentSignInManage.vue?vue&type=script&lang=js"
export * from "./CollegeStudentSignInManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b1256e",
  null
  
)

export default component.exports